module.exports = __webpack_public_path__ + "img/sound-effect-play.d076c3c7.svg";